import { NavLink } from 'react-router-dom';
import styled, { css, spacingBase } from 'theme';

interface LinkProps {
  primary?: number;
  listitem?: number;
  inline?: number;
  disabled?: boolean;
}

const LinkStyles = css<LinkProps>`
  display: ${(p) => (p.inline ? 'inline-flex' : 'flex')};
  line-height: 1.8;
  color: ${(p) => (p.primary ? 'var(--sys-color-primary)' : 'var(--ref-color-blackwhite-black)')};
  font-weight: var(--ref-font-weight-600);

  > span {
    margin-right: ${() => spacingBase};
  }

  svg {
    fill: ${(p) => (p.primary ? 'var(--sys-color-primary)' : 'var(--ref-color-blackwhite-black)')};
    align-self: center;

    &.list-item {
      margin-right: ${() => spacingBase};
    }
  }

  &:hover {
    text-decoration: underline;
  }

  ${(p) =>
    p.disabled &&
    css`
      pointer-events: none;
      opacity: 0.3;
    `}
`;

export const Link = styled.a`
  ${LinkStyles}
`;

export const InternalLink = styled(NavLink)`
  ${LinkStyles}
`;

export const Button = styled.button`
  border: 0;
  background: transparent;
  cursor: pointer;
  padding: 0;
  text-align: left;
  ${LinkStyles}
`;
